import { createStore } from "vuex";
import Emails from "../../../core/controls/emails/index";
import Persistence from "../../../core/controls/Persistence/index";
import auth from "../../../core/controls/auth/index";
import Groups from "../../../core/controls/groupsAndCals/groups";
import Calendars from "../../../core/controls/groupsAndCals/tymetool";
import Documents from "./Documents";
import { useMyMixin } from '../mixins/connectToHubs';
const { getJWT } = useMyMixin();
import router from '../router';
// import { showToast } from "../../../core/utils/showToast";
import { showToast } from "../../../core/utils/showToast";



// import UserJouneys from '../../../../core/controls/userJourneys/index';
// import emailPayload from "../../../../../labs/email_payload.json";
// import knowledgeBase from "../../../../../labs/flatEmailTreeView.json";

export default createStore({
  state: {
    needsAccessCode: false,
    possibleNavigationPaths: [
        {
          text: "Insights",
          path: "/insights",
          icon: "chart",
          getDataForRoute: "aiThemeTags"
        },
        {
            text: "Tags",
            path: "/tags",
            icon: "smalliconslayout",
            getDataForRoute: "emailModelTags"
          },
          {
            text: "Knowledge Base",
            path: "/emailkb",
            icon: "hierarchy",
            getDataForRoute: "emailKnowledgeBaseNode"
          },
    ],
    appNavigation: [
      {
        text: "Data",
        icon: "email",
        items: [
          {
            text: "Sync Emails",
            path: "/sync",
            icon: "refresh"
          },
          {
            text: "AI Tags",
            path: "/aitags",
            icon: "globe"
          }
        ]
      }
    ]
  },
  getters: {
    needsAccessCode(state) {
      return state.needsAccessCode
    },
    appNavigation(state) {
      return state.appNavigation;
    }
  },
  mutations: {
    addNavigationPath(state, text) {
    if (!state.appNavigation?.[0]?.items) return;
    
    const pathToAdd = state.possibleNavigationPaths.find(navObject => navObject.text === text);
    if (!pathToAdd) return;

    // Check if the item already exists in the navigation list
    const alreadyExists = state.appNavigation[0].items.some(item => item.text === text);
    
    if (!alreadyExists) {
      state.appNavigation[0].items.unshift(pathToAdd);
    }
  }
  },
  actions: {
    navigateToLoginForm() {
      showToast("You have been logged out. Please log in again", "");
      router.push('/login-form');
    },
    async applicationSpecificStartup(context) {
      await getJWT();
      context.dispatch("fetchKnowledgeBase");
      //connectToHubs();

      return {
        isOk: true,
        data: context.getters.getUser.email
      }
    },
    // async register(context) {

    //   const user ={
    //     Password: "lanternsoft",
    //     ConfirmPassword: "lanternsoft",
    //     UserName: "zack",
    //     EmailAddress: "zacky97@gmail.com"
    //   }

    //   console.log(context.getters.apiKey);

    //   let res = await fetch('http://localhost:1242/Register', {
    //     headers: {
    //       Accept: "application/json",
    //       "Content-Type": "application/json",
    //       ApiKey: context.getters.apiKey,
    //       // AccessCode: formData.accessCode,
    //     },
    //     method: "POST",
    //     body: JSON.stringify(user),
    //   })

    //   const json = await res.json();

    //   console.log(json);
    // },
    async fetchAllEmails() {

      //   THE CODE TO CALL EMAILS FROM THE NEW ENDPOINT  

      //   let res = await fetch("fetch from the new email endpoint", {});

      //   let emails = await res.json();

      //   emails.forEach((email) => {
      //     context.commit("addEmail", email);
      //   });

    },
    /* async fetchKnowledgeBase(context) {
      let res = await fetch(`${context.getters.VUE_APP_APIURL}/EmailKnowledgeBase`, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        method: "GET"
      })
      console.log("🚀 ~ fetchKnowledgeBase called");

      let kb = await res.json();
      context.commit('emailKnowledgeBase', kb);

    }, */
  },
  modules: {
    Emails,
    auth,
    Groups,
    Calendars,
    Documents,
    Persistence
    // UserJouneys
  },
});
